import Dexie, { Table } from 'dexie'
import {
	DexieQuizResults,
	DexieQuestion,
	DexieQuiz,
	DexieBadgeGroup,
	DexieBadge,
	DexieTrigger,
	DexieRecentlyEarnedBadge,
	DexieFavouritedKeys,
	DexieFavouritedItem,
} from './types'

export class IndexedDB extends Dexie {
	quizzes?: Table<DexieQuiz, number>
	quizQuestions!: Table<DexieQuestion, number>
	quizResults!: Table<DexieQuizResults, number>
	recentlyEarnedBadges!: Table<DexieRecentlyEarnedBadge, number>
	favouritedKeys!: Table<DexieFavouritedKeys, string>
	favouritedItems!: Table<DexieFavouritedItem, string>
	badgeGroups!: Table<DexieBadgeGroup, number>
	badges!: Table<DexieBadge, number>
	triggers!: Table<DexieTrigger, number>

	constructor(name: string) {
		super(name)
		this.version(6).stores({
			quizzes: '++id, version',
			quizQuestions: '++id, quiz_id',
			quizResults: '++question_id, quiz_id, correct',
			recentlyEarnedBadges: '++badge_id',
			favouritedKeys: '++key',
			favouritedItems: '++key',
			badgeGroups: '++id, version',
			badges: '++id, group_id',
			triggers: '++id, triggerable_id, badge_id, trigger_type',
		})
	}
}

const db = new IndexedDB('database')

export default db
